<div class="col-md-12 fance-modal">
  <div class="col-md-12">
    <div *ngIf="!config.data.isAdd" class="col-md-12">
      <label for="" class="col-md-4">Fence ID</label>
      <input type="text" [(ngModel)]="fenceDetails['geo_cd']" disabled>
    </div>
    <div class="col-md-12">
      <label for="" class="col-md-4">Fence Name<i style="color: red;">*</i></label>
      <input type="text" [(ngModel)]="fenceDetails['geo_nm']" [disabled]="config.data.isFromTransaction">
    </div>
    <div class="col-md-12">
      <label for="" class="col-md-4">Description</label>
      <input type="text" [(ngModel)]="fenceDetails['description']" [disabled]="config.data.isFromTransaction">
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-default" (click)="onCloseFence()">Close</button>
    <button *ngIf="buttonValidations.canCancel" class="btn btn-default" (click)="onCancelFence()">Cancel</button>
    <button *ngIf="buttonValidations.canSaveAndEdit" class="btn btn-default" (click)="onEditFence()">Edit</button>
    <button *ngIf="buttonValidations.canDel" class="btn btn-default" (click)="onDeleteFence()">Delete</button>
    <button *ngIf="buttonValidations.canSaveAndEdit" class="btn btn-primary" (click)="onSaveFence()"
      [disabled]="!fenceDetails['geo_nm']">Save</button>
  </div>
</div>
